
(() => {
  const money = (cents) => {
    try {
      return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format((Number(cents) || 0) / 100);
    } catch (e) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  };

  const cartEndpoint = () => (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';
  const cartUrl = () => (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';

  async function addItems(items, button) {
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const payload = { items };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart.getSectionsToRender().map((section) => section.id);
      payload.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function' && button) cart.setActiveElement(button);
    }

    if (button) {
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
    }

    try {
      const response = await fetch(cartEndpoint(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload)
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Unable to add to cart.');

      if (cart && typeof cart.renderContents === 'function' && data.sections) {
        if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(data);
      } else {
        window.location.href = cartUrl();
      }
      return data;
    } finally {
      if (button) {
        button.removeAttribute('aria-busy');
        button.disabled = false;
      }
    }
  }

  function initMain(root) {
    const productRoot = root.querySelector('[data-kotn-product]');
    if (!productRoot || productRoot.dataset.kotnInit === 'true') return;
    productRoot.dataset.kotnInit = 'true';

    const stage = productRoot.querySelector('[data-kotn-stage]');
    const stageImg = productRoot.querySelector('[data-kotn-stage-img]');
    const thumbs = productRoot.querySelector('[data-kotn-thumbs]');

    const setStageImage = (src, clearThumbs = true) => {
      if (!src || !stageImg) return;
      stageImg.removeAttribute('srcset');
      stageImg.removeAttribute('sizes');
      stageImg.src = src;
      stageImg.style.transformOrigin = '';
      stage && stage.classList.remove('zoom');
      if (clearThumbs && thumbs) {
        thumbs.querySelectorAll('[data-kotn-thumb]').forEach((t) => t.classList.remove('active'));
      }
    };

    if (thumbs && stageImg) {
      thumbs.addEventListener('click', (event) => {
        const btn = event.target.closest('[data-kotn-thumb]');
        if (!btn) return;
        if (btn.dataset.src) setStageImage(btn.dataset.src, false);
        thumbs.querySelectorAll('[data-kotn-thumb]').forEach((t) => t.classList.remove('active'));
        btn.classList.add('active');
      });
    }

    if (stage && stageImg) {
      stage.addEventListener('click', () => stage.classList.toggle('zoom'));
      stage.addEventListener('mousemove', (event) => {
        if (!stage.classList.contains('zoom')) return;
        const r = stage.getBoundingClientRect();
        stageImg.style.transformOrigin = `${((event.clientX-r.left)/r.width)*100}% ${((event.clientY-r.top)/r.height)*100}%`;
      });
    }

    const desc = productRoot.querySelector('[data-kotn-desc]');
    const more = productRoot.querySelector('[data-kotn-more]');
    if (desc && more) {
      more.addEventListener('click', () => {
        const clamped = desc.classList.toggle('clamp');
        more.textContent = clamped ? (more.dataset.more || 'Read more') : (more.dataset.less || 'Show less');
      });
    }

    let variants = [];
    const variantsEl = productRoot.querySelector('[data-kotn-variants]');
    if (variantsEl) {
      try { variants = JSON.parse(variantsEl.textContent || '[]'); } catch (e) {}
    }

    const groups = [...productRoot.querySelectorAll('[data-kotn-option-group]')]
      .sort((a,b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition));

    const variantId = productRoot.querySelector('[data-kotn-variant-id]');
    const qtyInput = productRoot.querySelector('[data-kotn-qty-input]');
    const priceNow = productRoot.querySelector('[data-kotn-price]');
    const priceWas = productRoot.querySelector('[data-kotn-compare]');
    const priceSave = productRoot.querySelector('[data-kotn-save]');
    const beerDollars = productRoot.querySelector('[data-kotn-beer-dollars]');
    const stock = productRoot.querySelector('[data-kotn-stock]');
    const addBtn = productRoot.querySelector('[data-kotn-add]');
    const expressBtn = productRoot.querySelector('[data-kotn-express]');
    const errorBox = productRoot.querySelector('[data-kotn-error]');
    const stickyPrice = document.querySelector('[data-kotn-sticky-price]');
    const stickyCompare = document.querySelector('[data-kotn-sticky-compare]');
    const stickySave = document.querySelector('[data-kotn-sticky-save]');

    function selectedValues() {
      return groups.map((group) => {
        const selected = group.querySelector('.vopt.on');
        return selected ? selected.dataset.optionValue : null;
      });
    }

    function findVariant() {
      const values = selectedValues();
      return variants.find((v) => Array.isArray(v.options) && v.options.every((opt, idx) => opt === values[idx]));
    }

    function updateVariant() {
      const variant = findVariant();
      if (!variant) {
        if (variantId) variantId.value = '';
        if (addBtn) { addBtn.disabled = true; addBtn.querySelector('span') && (addBtn.querySelector('span').textContent = 'UNAVAILABLE'); }
        if (expressBtn) expressBtn.disabled = true;
        if (stock) stock.innerHTML = '<i></i>Unavailable';
        return;
      }

      if (variantId) variantId.value = variant.id;
      if (priceNow) priceNow.textContent = money(variant.price);
      if (priceWas) {
        if (variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
          priceWas.textContent = money(variant.compare_at_price);
          priceWas.classList.remove('kotn-hide');
        } else {
          priceWas.textContent = '';
          priceWas.classList.add('kotn-hide');
        }
      }
      const saving = Math.max(0, Number(variant.compare_at_price || 0) - Number(variant.price || 0));
      if (priceSave) {
        priceSave.textContent = saving > 0 ? `Save ${money(saving).replace('.00','')}` : '';
        priceSave.classList.toggle('kotn-hide', saving <= 0);
      }
      if (beerDollars) beerDollars.textContent = Math.round(Number(variant.price || 0) / 100);
      if (stock) stock.innerHTML = variant.available ? '<i></i>In stock, ready to dispatch' : '<i></i>Sold out';
      if (addBtn) {
        addBtn.disabled = !variant.available;
        const span = addBtn.querySelector('span');
        if (span) span.textContent = variant.available ? (addBtn.dataset.label || 'ADD TO CART') : 'SOLD OUT';
      }
      if (expressBtn) expressBtn.disabled = !variant.available;

      if (stickyPrice) stickyPrice.textContent = money(variant.price);
      if (stickyCompare) {
        stickyCompare.textContent = variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price) ? money(variant.compare_at_price) : '';
      }
      if (stickySave) stickySave.textContent = saving > 0 ? ` Save ${money(saving).replace('.00','')}` : '';

    }

    groups.forEach((group) => {
      group.addEventListener('click', (event) => {
        const btn = event.target.closest('.vopt');
        if (!btn || btn.disabled) return;
        group.querySelectorAll('.vopt').forEach((b) => b.classList.remove('on'));
        btn.classList.add('on');
        const label = group.querySelector('[data-kotn-selected-label]');
        if (label) label.textContent = btn.dataset.optionValue || '';

        updateVariant();

        const optionName = (group.dataset.optionName || '').trim().toLowerCase();
        if (optionName === 'font type' && btn.dataset.mainImage) {
          setStageImage(btn.dataset.mainImage);
        }
      });
    });

    productRoot.querySelectorAll('[data-kotn-upsell]').forEach((btn) => {
      btn.addEventListener('click', () => btn.classList.toggle('on'));
    });

    const postcodeInput = productRoot.querySelector('[data-kotn-postcode-input]');
    const postcodeButton = productRoot.querySelector('[data-kotn-postcode-check]');
    const postcodeNote = productRoot.querySelector('[data-kotn-postcode-note]');
    const checkPostcode = () => {
      if (!postcodeInput || !postcodeNote) return;
      const value = postcodeInput.value.trim();
      if (!/^\d{4}$/.test(value)) {
        postcodeNote.classList.remove('ok');
        postcodeNote.textContent = 'Enter a valid 4-digit Australian postcode.';
        return;
      }
      postcodeNote.classList.add('ok');
      postcodeNote.textContent = `Postcode ${value} entered. Shipping options and availability are confirmed at checkout.`;
    };
    postcodeButton && postcodeButton.addEventListener('click', checkPostcode);
    postcodeInput && postcodeInput.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') { event.preventDefault(); checkPostcode(); }
    });

    const qMinus = productRoot.querySelector('[data-kotn-qminus]');
    const qPlus = productRoot.querySelector('[data-kotn-qplus]');
    const qVal = productRoot.querySelector('[data-kotn-qval]');
    const setQty = (n) => {
      n = Math.max(1, Number(n) || 1);
      if (qtyInput) qtyInput.value = n;
      if (qVal) qVal.textContent = n;
    };
    qMinus && qMinus.addEventListener('click', () => setQty((Number(qtyInput?.value) || 1) - 1));
    qPlus && qPlus.addEventListener('click', () => setQty((Number(qtyInput?.value) || 1) + 1));

    function buildItems() {
      const id = Number(variantId?.value || 0);
      if (!id) return [];
      const items = [{ id, quantity: Math.max(1, Number(qtyInput?.value) || 1) }];
      productRoot.querySelectorAll('[data-kotn-upsell].on').forEach((btn) => {
        const upsellId = Number(btn.dataset.variantId || 0);
        if (upsellId) items.push({ id: upsellId, quantity: 1 });
      });
      return items;
    }

    const form = productRoot.querySelector('[data-kotn-form]');
    if (form) {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (errorBox) errorBox.textContent = '';
        try {
          const items = buildItems();
          if (!items.length) throw new Error('Please choose an available option.');
          await addItems(items, addBtn);
        } catch (e) {
          if (errorBox) errorBox.textContent = e.message || 'Unable to add to cart.';
        }
      });
    }

    if (expressBtn) {
      expressBtn.addEventListener('click', async () => {
        if (errorBox) errorBox.textContent = '';
        try {
          const items = buildItems();
          if (!items.length) throw new Error('Please choose an available option.');
          await fetch(cartEndpoint(), {
            method:'POST',
            headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
            body:JSON.stringify({items})
          });
          window.location.href = '/checkout';
        } catch (e) {
          if (errorBox) errorBox.textContent = e.message || 'Unable to continue to checkout.';
        }
      });
    }

    document.querySelectorAll('[data-kotn-sticky-add]').forEach((btn) => {
      btn.addEventListener('click', () => addBtn && addBtn.click());
    });

    const modalTriggers = productRoot.querySelectorAll('[data-kotn-modal-open]');
    const infoModals = productRoot.querySelectorAll('[data-kotn-modal]');
    let modalReturnFocus = null;

    const closeInfoModal = (modal) => {
      if (!modal) return;
      modal.hidden = true;
      if (![...infoModals].some((item) => item.hidden === false)) document.body.style.overflow = '';
      if (modalReturnFocus && typeof modalReturnFocus.focus === 'function') modalReturnFocus.focus();
      modalReturnFocus = null;
    };

    const openInfoModal = (name, trigger) => {
      const modal = productRoot.querySelector(`[data-kotn-modal="${name}"]`);
      if (!modal) return;
      modalReturnFocus = trigger || null;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      const close = modal.querySelector('.kotn-info-modal__close');
      if (close) requestAnimationFrame(() => close.focus());
    };

    modalTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => openInfoModal(trigger.dataset.kotnModalOpen, trigger));
    });

    infoModals.forEach((modal) => {
      modal.querySelectorAll('[data-kotn-modal-close]').forEach((control) => {
        control.addEventListener('click', () => closeInfoModal(modal));
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      infoModals.forEach((modal) => { if (!modal.hidden) closeInfoModal(modal); });
    });

    updateVariant();
  }

  function initFAQ() {
    document.querySelectorAll('.kot-noir .qa > button').forEach((button) => {
      if (button.dataset.kotnInit === 'true') return;
      button.dataset.kotnInit = 'true';
      button.addEventListener('click', () => {
        const qa = button.parentElement;
        const container = qa.closest('.faq');
        const wasOpen = qa.hasAttribute('open');
        if (container) container.querySelectorAll('.qa').forEach((x) => x.removeAttribute('open'));
        if (!wasOpen) qa.setAttribute('open','');
      });
    });
  }

  function initQuickAdd() {
    document.querySelectorAll('[data-kotn-quick-add]').forEach((button) => {
      if (button.dataset.kotnInit === 'true') return;
      button.dataset.kotnInit = 'true';
      button.addEventListener('click', async () => {
        const id = Number(button.dataset.variantId || 0);
        if (!id) return;
        try { await addItems([{id, quantity:1}], button); }
        catch (e) { console.error(e); }
      });
    });
  }

  function init() {
    document.querySelectorAll('.kot-noir').forEach(initMain);
    initFAQ();
    initQuickAdd();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
